import { TranslationLoaderHelper } from 'app/core/internationalization/translation-loader-helper';

export abstract class BaseTranslatableModule {
  public constructor(protected translationLoaderHelper: TranslationLoaderHelper, protected moduleName: string) {
    // fire and forget to load the module's tranlsations
    translationLoaderHelper.mergeModuleTranslations(this.moduleName)
      .catch((error: unknown) => {
        console.warn(`[i18n] Failed to load module "${moduleName}"`, error);
      });
  }
}
